export const name = "ST_ASTEXT";
export const summary = `Converts a \`GEOGRAPHY\` value to a \`STRING\` WKT geography value.`;
export const reference = `
## ST_ASTEXT

Converts a \`GEOGRAPHY\` value to a \`STRING\` WKT geography value.

\`\`\`
ST_ASTEXT(geography_expression)
\`\`\`

### Description

Returns the WKT representation of an input\`GEOGRAPHY\`.

See \`ST_GEOGFROMTEXT\` to construct a\`GEOGRAPHY\` from WKT.


### Return type

\`STRING\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
